import type { InputHTMLAttributes, ReactNode } from 'react';
import { FormField } from './FormField';
import { Input } from './Input';
import { InfoTip } from './InfoTip';

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Field label. */
  label: ReactNode;
  /** Optional help text shown in an ⓘ tooltip next to the label (keeps the form compact). */
  infoTip?: string;
  /** Marks the field required (shows the `*`). Also sets the input's `required` attr. */
  required?: boolean;
  /** Validation message; also flags the input's error state. */
  error?: string;
}

/**
 * Common labeled text input = FormField (label / required / error) + Input
 * (token-driven styling). One control so every form gets consistent label
 * sizing, spacing, error display, and an optional InfoTip — instead of each
 * page hand-rolling its own `<label>` + `<input>`.
 */
export function TextField({ label, infoTip, required, error, ...inputProps }: TextFieldProps) {
  return (
    <FormField
      label={<>{label}{infoTip ? <> <InfoTip text={infoTip} /></> : null}</>}
      required={required}
      error={error}
    >
      <Input error={!!error} required={required} {...inputProps} />
    </FormField>
  );
}
